"use client";

import { c as _c } from "react/compiler-runtime";
import { CreateTrialCard } from "@/components/Paywall/_components/CreateTrialCard/CreateTrialCard.component";
import { PaywallLoginNotification } from "@/components/Paywall/_components/PaywallLoginNotification/PaywallLoginNotification.component";
import { ProductPageLink } from "@/components/Paywall/_components/ProductPageLink/ProductPageLink.component";
export function UnauthenticatedTrialFocusPaywall() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="border-smoke border-t border-solid" data-testid="unauthenticated-trial-focus-paywall"><div className="mx-auto flex max-w-xl flex-col space-y-5 pt-5 text-center"><PaywallLoginNotification /><CreateTrialCard /><ProductPageLink /></div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}